import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';

@Component({
  selector: 'app-project-option-radio',
  templateUrl: './project-option-radio.component.html',
  styleUrls: [],
  standalone: true,
  imports: [CommonModule, FormsModule, NzRadioModule]
})
export class ProjectOptionRadioComponent implements OnInit {
  @Input() projectOpt: any = '-2';
  @Input() name: string = 'project';
  @Input() resetOnChange: boolean = true;
  
  @Output() readonly projectOptChange = new EventEmitter<any>();
  @Output() readonly reset = new EventEmitter<void>();

  isProjectRestricted: boolean = false;

  constructor(private userDefaultService: UserDefaultService) {}

  ngOnInit(): void {
    this.userDefaultService.isProjectRestricted().subscribe(isRestricted => {
      this.isProjectRestricted = isRestricted;
      // If restriction is enabled and current option is "All Projects", default to "Sub Project"
      if (this.isProjectRestricted && this.projectOpt === '-2') {
        this.projectOpt = '3';
        this.projectOptChange.emit(this.projectOpt);
      }
    });
  }

  onProjectOptChange(value: any): void {
    this.projectOpt = value;
    this.projectOptChange.emit(value);
    if (this.resetOnChange) {
      this.reset.emit();
    }
  }
}

